"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ordering = void 0;
const _internals_1 = require("../_internals");
const symbols_1 = require("../_internals/symbols");
const enum_1 = __importDefault(require("./enum"));
const eq_1 = __importDefault(require("./eq"));
const show_1 = __importDefault(require("./show"));
const union_1 = __importDefault(require("./union"));
const mark = (0, symbols_1.setTypeclass)("Ord");
const rawCases = ["LT", "EQ", "GT"];
const Ordering = (0, union_1.default)("Ordering", {
    LT: () => { },
    EQ: () => { },
    GT: () => { },
}, [
    (0, eq_1.default)({ empties: rawCases }),
    (0, enum_1.default)({ order: rawCases }),
    Ord({ order: rawCases }),
    (0, show_1.default)({ overrides: {
            show: rawCases.reduce((acc, next) => {
                return (0, _internals_1.assoc)(next, () => `[Ordering => ${next}]`, acc);
            }, {})
        } }),
    (cases, globals) => {
        rawCases.forEach((key) => {
            globals[key] = new cases[key]();
        });
    }
]).constructors({});
exports.Ordering = Ordering;
/**
 * Partial ordering. Adds compare, lessThanOrEqual, greaterThan and greaterThanOrEqual methods to proto.
 * __Requires order or overrides for either lessThanOrEqual or compare__
 * @param defs
 * @returns
 */
function Ord(defs) {
    return mark((cases) => {
        let ltBased = false;
        let compareBased = false;
        let orderBased = false;
        let order = [];
        let lessThanOrEqual = _internals_1.identity;
        let compare = _internals_1.identity;
        if ("order" in defs) {
            orderBased = true;
            order = defs.order;
        }
        else if ("overrides" in defs) {
            if ("compare" in defs.overrides) {
                compareBased = true;
                compare = defs.overrides.compare;
            }
            else {
                ltBased = true;
                lessThanOrEqual = defs.overrides.lessThanOrEqual;
            }
        }
        (0, _internals_1.forEachValue)(variant => {
            if (ltBased) {
                variant.prototype.lessThanOrEqual = lessThanOrEqual;
                variant.prototype.compare = function (o) {
                    if (this.lessThanOrEqual(o)) {
                        if (o.lessThanOrEqual(this)) {
                            return Ordering.EQ;
                        }
                        return Ordering.LT;
                    }
                    return Ordering.GT;
                };
            }
            else if (compareBased) {
                variant.prototype.compare = compare;
                variant.prototype.lessThanOrEqual = function (o) {
                    return !this.compare(o).isGT();
                };
            }
            else if (orderBased) {
                variant.prototype.lessThanOrEqual = function (o) {
                    const getOrder = (y) => order.findIndex(x => x === (0, symbols_1.getVariant)(y));
                    const a = getOrder(this);
                    const b = getOrder(o);
                    return a <= b;
                };
                variant.prototype.compare = function (o) {
                    if (this.lessThanOrEqual(o)) {
                        if (o.lessThanOrEqual(this)) {
                            return Ordering.EQ;
                        }
                        return Ordering.LT;
                    }
                    return Ordering.GT;
                };
            }
            else {
                throw Error("Ord requires order or overrides for either compare or lessThanOrEqual");
            }
            variant.prototype.lessThan = function (o) {
                return this.compare(o).isLT();
            };
            variant.prototype.greaterThan = function (o) {
                return this.compare(o).isGT();
            };
            variant.prototype.greaterThanOrEqual = function (o) {
                return !this.compare(o).isLT();
            };
        }, cases);
    });
}
mark(Ord);
exports.default = Ord;
